var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.ugla = {
	searchForm: function () {
		$('.box_search :input')
			.focus(function () {
				$(this).siblings('label').css('opacity', 0);
			})
			.blur(function () {
				if ($(this).val().length == 0) {
					$(this).siblings('label').css('opacity', 1);
				}
			});
	}
};

site.qnFront = {
	init: function() {
		if ($(window).width()+15 <= 991) {
			//News categories dropdown
			var $qnFront = $('.qnFront');

			if ($qnFront.length > 0) {
				var $categories = $('#categories');

				$categories.on('click', function(e) {
					e.stopPropagation();
				});

				$('> ul > li', $categories).on('click', function (e) {
					$('body').toggleClass('categories-open');

					$('body.categories-open').on('click', function (e) {
						$('body').removeClass('categories-open');
					});
				});

				$('ul ul', $categories).each(function() {
					$(this).css('max-height', $(this)[0].scrollHeight);
				});
			}
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.empHide = {
	init: function () {
		if ($("body").hasClass("employees")) {
			$("#filterSearch").on("input", function() {
				var inputLength = $(this).val().length;
				if (inputLength >= 2) {
					$(".staff").removeClass("hideAll");
				} else {
					$(".staff").addClass("hideAll");
				}
			});
		}
	}
}


site.frontpage = {
	init: function() {
		site.frontpage.scroll();
	},

	scroll: function() {
		$('span.scroll span', '.box.scroll').on('click', function() {
			var target = $(this).parents('.box').next();
			var offset = 70;
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-offset
				}, 1000);
				return false;
			}

		});
	}
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	}
});

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.qnFront.init();
	site.empHide.init();
	//site.svg.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.ugla')) {
		site.ugla.searchForm();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
